// 将移动端优化样式集成到主应用
import '../assets/mobileOptimizations.css';

// 应用移动端优化
const applyMobileOptimizations = () => {
  // 添加触摸事件处理
  enhanceTouchInteractions();
  
  console.log('移动端优化样式已应用');
};

// 增强触摸交互
const enhanceTouchInteractions = () => {
  // 添加触摸反馈效果
  document.addEventListener('touchstart', (e) => {
    if (e.target.tagName === 'BUTTON' || 
        e.target.tagName === 'A' || 
        e.target.classList.contains('el-button') ||
        e.target.classList.contains('el-menu-item')) {
      e.target.classList.add('touch-active');
    }
  }, { passive: true });
  
  document.addEventListener('touchend', () => {
    const activeElements = document.querySelectorAll('.touch-active');
    activeElements.forEach(el => el.classList.remove('touch-active'));
  }, { passive: true });
};

export default applyMobileOptimizations;
